import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, List, Tabs, Tag, Dropdown, Menu } from 'antd';
import { updateCookie } from '../../utils/index';
import { DragSort, DragItem } from '../../components/DragSort';
//DragHandle
import { arrayMoveImmutable } from 'array-move';
import s from './style.m.less';
import { getTenantPortals } from '@/api/gateway';
import { LoadingOutlined } from '@ant-design/icons';

@inject('store')
@observer
class SelectTenant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            portalList: [],
            dropdownLoading: false
        };
    }
    outLogin = () => {
        const {
            store: { login }
        } = this.props;

        login.outLogin();
    };
    enter = (item) => {
        const {
            store: { login }
        } = this.props;
        if (login.activeIdentity === 'admin') {
            updateCookie(item);
            window.location.href = `https://${item.domain}`;
        }
        return;
    };

    //拖拽
    onSortEnd = (dragProps) => {
        const {
            store: { login }
        } = this.props;
        let { oldIndex, newIndex } = dragProps;

        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable(login.showTenantList.slice(), oldIndex, newIndex).filter((el) => Boolean(el));

            let ids = [];
            newData.forEach((ele) => {
                ids.push(ele.id);
            });

            // login.tenantSort(ids);
        }
    };

    getPortalList = async (item) => {
        this.setState({ dropdownLoading: true });
        let res = await getTenantPortals({ tenant_id: item.tenant_id }),
         data = res?.data ? res.data : [];
        this.setState({
            portalList: data,
            dropdownLoading: false
        });
    };

    onClickMenu = (item, ele) => {
        const {
            store: { login }
        } = this.props;
        if (login.activeIdentity === 'student') {
            window.location.href = `https://${item.domain}/web?source_id=${ele.portal_id}`;
        }
        return;
    };

    renderDropdownContent = (item) => {
        return (
            <Menu>
                {this.state.dropdownLoading ? (
                    <Menu.Item key="loading">
                        <LoadingOutlined /> 加载中...
                    </Menu.Item>
                ) : this.state.portalList?.length ? (
                    this.state.portalList.map((ele, index) => {
                        return (
                            <Menu.Item key={index} onClick={() => this.onClickMenu(item, ele)}>
                                {ele.portal_name}
                            </Menu.Item>
                        );
                    })
                ) : (
                    <Menu.Item key="empty">暂无数据</Menu.Item>
                )}
            </Menu>
        );
    };
    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <div style={{ height: '630px', paddingTop: '16px', overflowY: 'auto', overflowX: 'hidden' }}>
                <Tabs
                    activeKey={login.activeIdentity}
                    onChange={(e) => {
                        login.setActiveIdentity(e);
                    }}
                    items={[
                        {
                            label: '学员身份',
                            key: 'student',
                            children: <></>
                        },
                        {
                            label: '管理员身份',
                            key: 'admin',
                            children: <></>
                        }
                    ]}
                />

                {login.showTenantList?.length ? (
                    <DragSort onSortEnd={this.onSortEnd} useDragHandle key={'custom'} helperClass={s['sortableHelper']}>
                        <List
                            grid={{
                                gutter: 32,
                                column: 2
                            }}
                            className={s.list_box}
                            dataSource={login.showTenantList}
                            renderItem={(item, index) => (
                                <DragItem key={item.tenant_id} index={index}>
                                    <List.Item
                                        key={item.tenant_id}
                                        onClick={() => {
                                            this.enter(item);
                                        }}
                                    >
                                        <div className={s.tag}>
                                            {item.state === 0 ? null : (
                                                <Tag style={{ width: '78px' }} color="#FF3200">
                                                    {item.state === 1 ? ' 账号被停用' : item.state === 2 ? '租户被停用' : '租户已过期'}
                                                </Tag>
                                            )}
                                        </div>
                                        {login.activeIdentity === 'student' ? (
                                            <Dropdown
                                                overlay={this.renderDropdownContent(item)}
                                                overlayClassName={s['drop-class']}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                placement={'bottom'}
                                                autoFocus={true}
                                                onOpenChange={(open) => {
                                                    if (open) {
                                                        this.getPortalList(item);
                                                    } else {
                                                        this.setState({
                                                            portalList: [],
                                                            dropdownLoading: false
                                                        });
                                                    }
                                                }}
                                            >
                                                <Card hoverable>
                                                    <div
                                                        style={{
                                                            marginBottom: 0,
                                                            fontSize: '14px',
                                                            fontWeight: '500',
                                                            textAlign: 'center',
                                                            lineHeight: '38px'
                                                        }}
                                                    >
                                                        {item.tenant_name}
                                                    </div>
                                                </Card>
                                            </Dropdown>
                                        ) : (
                                            <Card hoverable>
                                                <div
                                                    style={{
                                                        marginBottom: 0,
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        textAlign: 'center',
                                                        lineHeight: '38px'
                                                    }}
                                                >
                                                    {item.tenant_name}
                                                </div>
                                            </Card>
                                        )}
                                    </List.Item>
                                </DragItem>
                            )}
                        />
                    </DragSort>
                ) : (
                    <div span={24} style={{ margin: '100px auto 0', textAlign: 'center' }}>
                        <div className={s.search_empty}></div>
                        <div
                            style={{
                                fontSize: '12px',
                                color: '#999'
                            }}
                        >
                            您当前暂无其他组织
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default SelectTenant;
